import sub from 'markdown-it-sub';

export default sub;
